<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        class="pa-6"
        style="background-color: #e5fcec; border: 1.5px solid #E8E8DD;"
      >
        <v-row align="center">
          <v-col
            cols="auto"
            class="pr-0 pt-2"
          >
            <v-btn
              color="primary"
              icon
              @click="isOpen = !isOpen"
            >
              <v-icon v-if="isOpen">
                mdi-chevron-up
              </v-icon>
              <v-icon v-else>
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <span style="color: #000000; font-size: 16px; font-weight: bold;">CUSTOM ITEMS ({{ itemCount }})</span>
          </v-col>
          <v-col
            v-if="!isItemOpen && !returnItem && !billOfLadingQr && !isView"
            class="text-end"
          >
            <v-btn
              color="primary"
              outlined
              @click="open()"
            >
              <v-icon
                small
                class="mr-1"
              >
                fas fa-plus
              </v-icon>
              CUSTOM ITEM
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-show="isOpen">
          <v-col>
            <v-row
              v-if="isItemOpen || items.length > 0"
            >
              <v-col
                cols="12"
                class=""
              >
                <span class="ma-1" style="color: #000000; font-weight: bold; font-size: 1rem;">Custom Items</span>
                <v-card
                  elevation="0"
                  outlined
                >
                  <v-data-table
                    v-model="selectedCustomItems"
                    :headers="customItemHeaders"
                    :items="items"
                    hide-default-footer
                    :items-per-page="-1"
                    dense
                    item-key="temp_id"
                  >
                    <template #[`item.name`]="{ item }">
                      <span v-if="item.bill_of_lading_extra_item_type">
                        {{ item.bill_of_lading_extra_item_type.name }}
                      </span>
                    </template>
                    <template #[`item.color`]="{ item }">
                      <span v-if="item.color">
                        {{ item.color.code }}
                      </span>
                    </template>
                    <template #[`item.uom`]="{ item }">
                      <span v-if="item.uom">
                        {{ item.uom.name }}
                      </span>
                    </template>
                    <template #[`item.weight`]="{ item }">
                      {{ item && item.weight ? `${item.weight.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}` : '-' }}
                    </template>
                    <!-- <template #[`item.quantity_supplied`]="{ item }">
                      <v-text-field
                        v-model="item.quantity_supplied"
                        :disabled="item.is_supplied || isSupplyingForBillOfLading || isView"
                        outlined
                        :hide-details="true"
                        dense
                        single-line
                        type="number"
                        min="0"
                        :max="item.quantity"
                        label="Enter Quantity Supplied"
                        :rules=" isPickState ? [(v) => v <= item.quantity || displayQuantitySuppliedRule()] : []"
                        class="mt-1 mb-1"
                        @click="supply(item)"
                      >
                          <template #append-outer>
                            <v-btn
                              v-if="!item.is_supplied && !isSupplyingForBillOfLading && !isView"
                              color="primary"
                              outlined
                              small
                              :disabled="isView">
                              SUPPLY
                            </v-btn>
                          </template>
                      </v-text-field>
                    </template> -->
                    <template #[`item.total_weight`]="{ item }">
                      {{ item && item.weight && item.quantity ? `${parseFloat(getCustomItemTotalWeight(item)).toLocaleString('en-US', { maximumFractionDigits: 2 })}` : '-' }}
                    </template>
                    <template #[`item.status`]="{ item }">
                      <v-chip
                        v-if="item.status"
                        small
                        text-color="white"
                        style="cursor: pointer;"
                        :color="item.status ? item.status.color : ''"
                      >
                        {{ item.status ? item.status.name : '' }}
                      </v-chip>
                    </template>
                    <template #[`item.actions`]="{ item }">
                      <!-- <v-btn
                        v-if="isPickState && !item.is_supplied"
                        class="ml-1 mt-1 mb-1"
                        color="warning"
                        outlined
                        small
                        @click="supply(item)"
                      >
                        SUPPLY
                      </v-btn> -->
                      <v-btn
                        v-if="!returnItem && !isView && !item.is_supplied"
                        class="ml-1 mt-1 mb-1"
                        color="primary"
                        outlined
                        small
                        @click="openEdit(item)"
                      >
                        EDIT
                      </v-btn>
                      <v-btn
                        v-if="!returnItem && !isView"
                        class="ml-1 mt-1 mb-1"
                        color="error"
                        outlined
                        small
                        @click="softDelete(item)"
                      >
                        DELETE
                      </v-btn>
                    </template>
                    <template slot="body.append">
                      <tr>
                        <th />
                        <th />
                        <th />
                        <th />
                        <th class="text-end pr-1">
                          <span style="color: #000000; font-weight: bold; font-size: 14px;">Totals: </span>
                        </th>
                        <th class="text-end">
                          <span style="font-weight: bold; font-size: 14px;">{{ parseFloat(getTotalUnitWeight()).toLocaleString('en-US', { maximumFractionDigits: 2 }) }}</span>
                        </th>
                        <th class="text-end">
                          <span style="font-weight: bold; font-size: 14px;">{{ getTotalQuantity() }}</span>
                        </th>
                        <!-- <th class="text-start"> 
                          <span
                            class="pl-3"
                            :style="{
                              color: isDarkMode ? '' : '#000000',
                              fontWeight: 'bold',
                              fontSize: '14px',
                            }"
                            style="
                              color: #000000;
                              font-weight: bold;
                              font-size: 14px;
                            "
                            >{{ getCustomItemTotalSupplied() }}</span
                          >
                        </th> -->
                        <th class="text-end">
                          <span style="font-weight: bold; font-size: 14px;">{{ parseFloat(getTotalWeightKilograms()).toLocaleString('en-US', { maximumFractionDigits: 2 }) }}</span>
                        </th>
                        <th v-if="!billOfLadingQr"/>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="isItemOpen">
              <v-col>
                <v-row>
                  <v-col class="pb-0">
                    <zig-zag bg-color="green" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-0">
                    <span style="font-size: 16px; color: #000000; font-weight: bold;"> {{ items.some(x => x.temp_id === item.temp_id) ? 'UPDATE' : 'NEW' }} INSTALLATION MATERIAL</span>
                  </v-col>
                </v-row>
                <v-form ref="form">
                  <v-row>
                    <v-col
                      cols="3"
                      md="3"
                      sm="6"
                      class="pb-0"
                    >
                      <v-row>
                        <v-col class="pb-0">
                          <span style="color: #000000;">Available Installation Materials</span><RedAsterisk />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pt-1">
                          <v-autocomplete
                            v-model="item.bill_of_lading_extra_item_type_id"
                            :items="billOfLadingExtraItemTypes"
                            :loading="loadingextraItemTypes"
                            item-text="name"
                            item-value="id"
                            solo
                            :rules="[(v) => !!v || 'Installation Material is required']"
                            @change="setWeight(item.bill_of_lading_extra_item_type_id)"
                          >
                            <template #append-outer>
                              <v-btn
                                color="primary"
                                outlined
                                small
                                @click="openBillOfLadingExtraItemTypeForm()"
                              >
                                <v-icon> mdi-plus </v-icon>
                              </v-btn>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="1"
                      md="1"
                      class="pb-0"
                    >
                      <v-row>
                        <v-col class="pb-0">
                          <span style="color: #000000;">Width</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pt-1">
                          <v-text-field
                            v-model="item.width"
                            placeholder="Enter Width"
                            solo
                            dense
                            type="number"
                            min="0"
                            suffix="inches"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="1"
                      md="1"
                      class="pb-0"
                    >
                      <v-row>
                        <v-col class="pb-0">
                          <span style="color: #000000;">Height</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pt-1">
                          <v-text-field
                            v-model="item.height"
                            placeholder="Enter Height"
                            solo
                            dense
                            type="number"
                            min="0"
                            suffix="inches"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="2"
                      md="2"
                      sm="6"
                      class="pb-0"
                    >
                      <v-row>
                        <v-col class="pb-0">
                          <span style="color: #000000;">Color</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pt-1">
                          <v-autocomplete
                            v-model="item.color_id"
                            :items="colors"
                            :loading="loadingColors"
                            item-text="code"
                            item-value="id"
                            solo
                            clearable
                          >
                            <template #selection="{ item }">
                              <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> {{ item.name ? `; ${item.name}` : '' }}</span>
                            </template>
                            <template #item="{ item }">
                              <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> {{ item.name ? `; ${item.name}` : '' }}</span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="1"
                      md="1"
                      class="pb-0"
                    >
                      <v-row>
                        <v-col class="pb-0">
                          <span style="color: #000000;">UOM</span><RedAsterisk />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pt-1">
                          <v-autocomplete
                            v-model="item.uom_id"
                            :items="uoms"
                            :loading="loadingUoms"
                            item-text="name"
                            item-value="id"
                            solo
                            :rules="[(v) => !!v || 'Uom is required']"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="2"
                      md="2"
                      sm="6"
                      class="pb-0"
                    >
                      <v-row>
                        <v-col class="pb-0">
                          <span style="color: #000000;">Weight</span><RedAsterisk />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pt-1">
                          <v-text-field
                            v-model="item.weight"
                            placeholder="Enter Weight"
                            solo
                            dense
                            type="number"
                            min="0"
                            suffix="kg"
                            :rules="[(v) => !!v || 'Weight is required']"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="2"
                      md="2"
                      sm="6"
                      class="pb-0"
                    >
                      <v-row>
                        <v-col class="pb-0">
                          <span style="color: #000000;">Quantity</span><RedAsterisk />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pt-1">
                          <v-text-field
                            v-model="item.quantity"
                            placeholder="Enter Quantity"
                            solo
                            dense
                            type="number"
                            min="1"
                            :rules="[(v) => !!v || 'Quantity is required']"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row>
                  <v-spacer />
                  <v-col
                    cols="auto"
                    class="pr-0"
                  >
                    <v-btn
                      color="normal"
                      class="mr-2"
                      @click="close()"
                    >
                      Cancel
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="auto"
                    class="pl-2"
                  >
                    <v-btn
                      color="primary"
                      @click="addItem"
                    >
                      {{ items.some(x => x.temp_id === item.temp_id) ? 'UPDATE' : 'ADD' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <confirm-form ref="confirmForm" />
    <bill-of-lading-extra-item-type-form
      ref="extraItemTypeForm"
      @success="getAddedExtraItemType"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ZigZag from '@/components/elements/ZigZag';
import BillOfLadingExtraItemTypeForm from '@/components/forms/billOfLadings/BillOfLadingExtraItemTypeForm.vue';

export default {
  components: {
    ZigZag,
    BillOfLadingExtraItemTypeForm
  },
  props: {
    returnItem: {
      type: Boolean,
      default: false,
    },
    billOfLadingQr: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    items: [],
    selectedCustomItems: [],
    billOfLadingExtraItemTypes: [],
    colors: [],
    uoms: [],
    item: null,
    // itemDto: {
    //   // id: 0,
    //   bill_of_lading_extra_item_type_id: null,
    //   width: null,
    //   height: null,
    //   color_id: null,
    //   uom_id: null,
    //   weight: 0,
    //   quantity: null,
    // },
    isOpen: true,
    isItemOpen: false,
    loadingextraItemTypes: false,
    loadingColors: false,
    loadingUoms: false,
  }),
  computed: {
    ...mapState({
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([]),
    customItemHeaders() {
      let headers = [];

      let defaultHeaders = [
        {
          text: 'Installation Material', value: 'name',  width: '10%', sortable: false,
        },
        { 
          text: 'Width (inches)', value: 'width', width: '10%', sortable: false,
        },
        { 
          text: 'Height (inches)', value: 'height', width: '10%', sortable: false,
        },
        { 
          text: 'Color', value: 'color', width: '10%', sortable: false,
        },
        { 
          text: 'Uom', value: 'uom', width: '5%', sortable: false,
        },
        { 
          text: 'Unit Weight (kg)', value: 'weight', align: 'end', width: '5%', sortable: false,
        },
        {
          text: 'Quantity Required', value: 'quantity', align: 'end', width: '5%', sortable: false,
        },
        // {
        //   text: 'Quantity Supplied', value: 'quantity_supplied', align: 'start', width: '15%', sortable: false,
        // },
        {
          text: 'Total Weight (kg)', value: 'total_weight', align: 'end', width: '5%', sortable: false,
        },
      ]

      headers = [...headers, ...defaultHeaders];

      if(!this.billOfLadingQr) {
        headers.push({
          text: 'Actions', value: 'actions', align: 'end', width: '15%', sortable: false,
        })
      }

      return headers;
    },

    itemDto() {
      const itemDto = {
        // id: 0,
        bill_of_lading_extra_item_type_id: null,
        width: null,
        height: null,
        color_id: null,
        uom_id: null,
        weight: 0,
        quantity: null,
      }
      return itemDto;
    },

    itemCount() {
      let itemCount = 0;
      if (this.items && this.items.length > 0) {
        itemCount = this.items.length;
      }
      return itemCount;
    },
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
    },

    async get(id) {
      const readModel = {
        filters: {
          commercial_bill_of_lading_id: id,
        },
      };

      const res = await this.$api.commercialBillOfLadingExtraItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || res.length === 0) {
        this.$bus.$emit('showError', 'Error reading extra items');
        return;
      }

      this.items = res.data;
    },

    async getExtraItemTypes() {
      this.loadingExtraItemTypes = true;

      const res = await this.$api.billOfLadingExtraItemType.get();
      if (!res || !res.length) {
        this.$bus.$emit(
          'showError',
          'Unable to retrieve available extra items',
        );
        return;
      }

      this.billOfLadingExtraItemTypes = res;
      this.loadingExtraItemTypes = false;
    },

    async getColors() {
      this.loadingColors = true;
      const submitModel = {
        filters: {
        },
      };

      this.colors = await this.$api.color.read(submitModel);
      this.loadingColors = false;
    },

    async getUoms() {
      this.loadingUoms = true;
      const submitData = {
        filters: {
        },
      };
      this.uoms = await this.$api.uom.read(submitData);
      this.loadingUoms = false;
    },

    async open() {
      // await this.getExtraItemTypes();
      this.isOpen = true;
      this.isItemOpen = true;
      this.item = { ...this.itemDto };
      this.item.temp_id = Date.now();
    },

    close() {
      this.isItemOpen = false;
    },

    openEdit(item) {
      this.item = { ...item };
      this.isItemOpen = true;
    },

    addItem() {
      if (!this.$refs.form.validate()) return;
      const billOfLadingExtraItemType = this.billOfLadingExtraItemTypes.find((x) => x.id === this.item.bill_of_lading_extra_item_type_id);
      const color = this.colors.find((x) => x.id === this.item.color_id);
      const uom = this.uoms.find((x) => x.id === this.item.uom_id);
      const item = this.items.find((x) => x.temp_id === this.item.temp_id);
      if (item) {
        const index = this.items.findIndex((x) => x.temp_id === this.item.temp_id);
        this.item.bill_of_lading_extra_item_type = billOfLadingExtraItemType;
        this.item.color = color;
        this.item.uom = uom;
        this.items.splice(index, 1, { ...this.item });
      } else {
        if (billOfLadingExtraItemType) {
          this.item.bill_of_lading_extra_item_type = billOfLadingExtraItemType;
          this.item.bill_of_lading_extra_item_type_id = billOfLadingExtraItemType.id;
          this.item.color = color;
          this.item.color_id = color ? color.id : null;
          this.item.uom = uom;
          this.item.uom_id = uom.id;
        }
        this.items.push(JSON.parse(JSON.stringify(this.item)));
      }

      // this.$emit('addExtraItem', { ...this.item });

      this.close();
    },

    async softDelete(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this installation material?',
      });
      if (!confirm) return;
      let index;
      if (item.id) {
        index = this.items.findIndex((x) => x.id === item.id);
      } else {
        index = this.items.findIndex((x) => x.temp_id === item.temp_id);
      }

      // const removedItem = this.items[index];
      this.items.splice(index, 1);

      // this.$emit('removeExtraItem', { ...removedItem });
    },

    submit() {
      //
    },

    // async supply(item) {
    //   const confirm = await this.$refs.confirmForm.open({
    //     title: `Are you sure you want to supply this Custom Item?`,
    //   });
    //   if (!confirm) return;
    //   this.$bus.$emit('loading');
    //   const res = await this.$api.billOfLadingExtraItem.get(`supply/${item.id}`);
    //   if (!res) {
    //     this.$bus.$emit('loading');
    //     this.$bus.$emit('showError');
    //     return false;
    //   }
    //   this.$bus.$emit('loading');
    //   this.$bus.$emit('showSuccess');
    //   this.$emit('custom-item-supplied', item);
    //   this.get(item.part_pick_list_id);
    // },

    openBillOfLadingExtraItemTypeForm() {
      this.$refs.extraItemTypeForm.open();
    },

    async getAddedExtraItemType() {
      await this.getExtraItemTypes();
      const latestItemId = Math.max(...this.billOfLadingExtraItemTypes.map((x) => x.id));
      if (latestItemId) { this.item.bill_of_lading_extra_item_type_id = latestItemId; }
      this.setWeight(this.item.bill_of_lading_extra_item_type_id);
    },

    setWeight(billOfLadingExtraItemTypeId) {
      if (!billOfLadingExtraItemTypeId) return;

      const billOfLadingExtraItemType = this.billOfLadingExtraItemTypes.find((x) => x.id === billOfLadingExtraItemTypeId);
      if (!billOfLadingExtraItemType) return;
      
      this.item.weight = billOfLadingExtraItemType.weight ?? 0;
    },

    getCustomItemTotalWeight(item) {
      return item.weight * item.quantity;
    },

    getTotalUnitWeight() {
      return this.items.reduce((acc, extraItem) => acc + parseFloat(extraItem.weight), 0);
    },

    getTotalQuantity() {
      return this.items.reduce((acc, extraItem) => acc + parseInt(extraItem.quantity), 0);
    },

    getTotalWeightKilograms() {
      return this.items.reduce((acc, extraItem) => acc + (parseFloat(extraItem.weight) * parseInt(extraItem.quantity)), 0);
    },
  },
};
</script>
<style scoped>
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  background-color: #FFFFFF !important;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th > span {
  color: #000000;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot
{
  border: 1px solid rgba(0,0,0,0.4) !important;
}
</style>
